module.exports = __webpack_public_path__ + "7acd0ee6d234d7afd43fdf2fb70ba4c1.png";